import type { VoidFunctionComponent } from 'react';

import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import Section from '../../../shared/settings/SettingsPageSection';

import type { IssueSettingsProps } from './types';

/**
 * ProjectSecurityIssuesSettings
 *
 * Security issue settings for a project
 */
const ProjectSecurityIssuesSettings: VoidFunctionComponent<IssueSettingsProps> = ({
  isSnippetScanningEnabled,
  onToggleSnippetScanning,
  isVendoredScanningEnabled,
  onToggleVendoredScanning,
  ...issuesSectionProps
}) => {
  return (
    <Section>
      <Section.Left heading="Security">
        <Section.Paragraph>Configuration for security issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Vulnerability}
          scopeType={IssueScopeKind.Project}
          isSnippetScanningEnabled={isSnippetScanningEnabled}
          onToggleSnippetScanning={onToggleSnippetScanning}
          isVendoredScanningEnabled={isVendoredScanningEnabled}
          onToggleVendoredScanning={onToggleVendoredScanning}
          {...issuesSectionProps}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectSecurityIssuesSettings;
